import type {StoryGuideline} from '@Components/social-media-wizard/components/social-media-publish-params-story-guideline';
import type {SocialPlatform} from '@Components/social-media/social-media.types';
import {getReadableAccounts} from '@Components/social-media/social-media.types';

export const WizardNavHeight = 56;
export const WizardMobileFooterHeight = 64;

export const WizardMobilePaddingOffsets = 16;

/**
 * For the mobile version, a single preview being displayed should never have a background that scrolls
 * and should be just spanning over the available screen space
 */
export const getMobilePreviewWindowHeight = (): number => {
  return window.innerHeight - (WizardNavHeight + WizardMobileFooterHeight + WizardMobilePaddingOffsets);
};

export const storyGuidelinesData = (platform: SocialPlatform): StoryGuideline[] => {
  const platformName = getReadableAccounts(platform);
  return [
    {
      emoji: `🛸`,
      text: window.i18next.t('pmwjs_story_caption_guideline_one', {platform: platformName}),
    },
    {
      emoji: `🤠`,
      text: window.i18next.t('pmwjs_story_caption_guideline_two', {platform: platformName}),
    },
    {
      emoji: `🦄`,
      text: window.i18next.t('pmwjs_story_caption_guideline_three', {platform: platformName}),
    },
    {
      emoji: `🍄`,
      text: window.i18next.t('pmwjs_story_caption_guideline_four', {platform: platformName}),
    },
    {
      emoji: `🍕`,
      text: window.i18next.t('pmwjs_story_caption_guideline_five', {platform: platformName}),
    },
    {
      emoji: `✋`,
      text: window.i18next.t('pmwjs_story_caption_guideline_six', {platform: platformName}),
    },
    {
      emoji: `💭`,
      text: window.i18next.t('pmwjs_story_caption_guideline_seven', {platform: platformName}),
    },
    {
      emoji: `🍁`,
      text: window.i18next.t('pmwjs_story_caption_guideline_eight', {platform: platformName}),
    },
    {
      emoji: `🎂`,
      text: window.i18next.t('pmwjs_story_caption_guideline_nine', {platform: platformName}),
    },
    {
      emoji: `🐾`,
      text: window.i18next.t('pmwjs_story_caption_guideline_ten', {platform: platformName}),
    },
    {
      emoji: `🚗`,
      text: window.i18next.t('pmwjs_story_caption_guideline_eleven', {platform: platformName}),
    },
  ];
};

const getRandomNumberInRange = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const getRandomNumberForStoryCaptionGuideline = (platform: SocialPlatform): number => {
  return getRandomNumberInRange(0, storyGuidelinesData(platform).length - 1);
};

export const getStoryGuidelineforIndex = (index: number, platform: SocialPlatform): StoryGuideline => {
  return storyGuidelinesData(platform)[index];
};

export const getUnusedRandomGuidelineNumber = (alreadyUsedRandomNumbers: number[], platform: SocialPlatform): number => {
  const maxNumRetries = 150;
  let retryCounter = 0;
  while (retryCounter < maxNumRetries) {
    const generatedNumber = getRandomNumberForStoryCaptionGuideline(platform);
    const indexFound = alreadyUsedRandomNumbers.indexOf(generatedNumber);

    retryCounter += 1;

    if (indexFound === -1) {
      return generatedNumber;
    }
  }

  return 0;
};
